// extracted by mini-css-extract-plugin
export default {"root":"rcVyDRSLGzNx81lqZuZM","placeHolderShimmer":"q1QSxGeBCp9hbP0eq01G"};